export const SLIDER_ANIMATION_TIMING = 200;
